<template>
    <div>
        <div class='about-bg'>
            <el-image :src="about_header" style=" width: 100%; margin-bottom: 3%"></el-image>
            <div class="about-item">
              <el-image v-show="$i18n.locale==='zh'" v-for="item in about_content" :src="item" :key="item" class="about-item-zh" style="width: 64%"></el-image>
              <div v-show="$i18n.locale==='zh'" class="about-copy">
                <p>博乐科技成立于2014年，是一家专注海外休闲游戏研发与运营的游戏公司，旗下产品覆盖北美、欧洲、东南亚等多个国家和地区，获得市场积极反馈，在全球多个地区拥有办公区，员工人数超千人。</p>
                <p>为了打造让更多玩家热爱的游戏，博乐汇聚了专业游戏产品、运营和技术人才，核心团队深耕出海市场多年，经验丰富、追求卓越。</p>
                <p>我们坚信优秀人才是公司发展的核心动力。期待渴望成长、热爱游戏的你加入我们，与可爱的游戏狂人一起，力求打造全球化精品游戏！</p>
              </div>
              <el-image v-show="$i18n.locale==='en'" :src="about_content_en" class="about-item-en"></el-image>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data(){
    return {
      about_header: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/about_header.jpg',
      // about_content: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/about_1.png',
      // about_content: `${require('../assets/img_grande/about_us_0324.png')}`,
      // about_content: `${require('../assets/img_grande/about_us_0805.png')}`,
      about_content: [
          `${require('../assets/images_new/new_about1.png')}`,
          `${require('../assets/images_new/new_about2.png')}`,
          `${require('../assets/images_new/new_about3.png')}`,
          `${require('../assets/images_new/new_about4.png')}`,
          `${require('../assets/images_new/new_about5.png')}`,
      ]

    }
  },
  computed: {
    //是否使用移动端视频
    about_content_en() {
      // return document.documentElement.clientWidth > 992 ? 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/about_1_en.png' : 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/about_en_mobile.png';
      return document.documentElement.clientWidth > 992 ? `${require('../assets/resource_10_23/about_us_en.png')}` : 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/about_en_mobile.png';
    },
  },
}
</script>

<style>
.about-item {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 50px;
}
.about-item-zh {
  width: 100%;
  /*margin-bottom: 3%*/
}
.about-copy {
  width: 64%;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 24px 48px 28px;
  background: rgba(7, 8, 32, 0.72);
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.85;
  letter-spacing: 1px;
  text-align: left;
}
.about-copy p {
  margin: 0 0 8px;
  text-indent: 2em;
}
.about-copy p:last-child {
  margin-bottom: 0;
}
.about-item-en {
  width: 100%;
  /*margin-bottom: 3%*/
}
@media screen and (max-width: 926px) {
  .about-item {
    margin-top: 20px;
    width: 110%;
    right: 5%;
    position: relative;
  }
  .about-item-en {
    width: 70%;
  }
  .about-copy {
    width: 64%;
    padding: 14px 18px 16px;
    font-size: 12px;
    line-height: 1.8;
    letter-spacing: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/About.vue